'use client'

import { useState } from 'react'

import { EyeClosed, Eye } from 'lucide-react'

import { FormItem } from '@/shared/form/FormItem'
import { Input } from '@/shared/form/Input'

import { validationSchema } from './validationSchema'

interface ResetPasswordFieldsProps {
  inputClassName?: string
}

export function ResetPasswordFields({
  inputClassName
}: ResetPasswordFieldsProps) {
  const [seePassword, setSeePassword] = useState(false)
  const [seePasswordConfirmation, setSeePasswordConfirmation] = useState(false)

  return (
    <>
      <FormItem name="password" vertical>
        <FormItem.Label>Senha</FormItem.Label>
        <div className="relative">
          <FormItem.Control>
            <Input
              name="password"
              type={seePassword ? 'text' : 'password'}
              autoComplete="new-password"
              className={inputClassName}
            />
          </FormItem.Control>
          <button
            type="button"
            className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-x-1 pr-3"
            onClick={() => setSeePassword(!seePassword)}
          >
            {seePassword ? (
              <Eye className="h-4 w-4 text-gray-500" />
            ) : (
              <EyeClosed className="h-4 w-4 text-gray-500" />
            )}
          </button>
        </div>
      </FormItem>

      <FormItem name="passwordConfirmation" vertical>
        <FormItem.Label>Confirme a senha</FormItem.Label>
        <div className="relative">
          <FormItem.Control>
            <Input
              name="passwordConfirmation"
              type={seePasswordConfirmation ? 'text' : 'password'}
              autoComplete="new-password"
              className={inputClassName}
            />
          </FormItem.Control>
          <button
            type="button"
            className="absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-x-1 pr-3"
            onClick={() => setSeePasswordConfirmation(!seePasswordConfirmation)}
          >
            {seePasswordConfirmation ? (
              <Eye className="h-4 w-4 text-gray-500" />
            ) : (
              <EyeClosed className="h-4 w-4 text-gray-500" />
            )}
          </button>
        </div>
      </FormItem>
    </>
  )
}

ResetPasswordFields.validationSchema = validationSchema
